<template>
	<div class="modal fade" ref="modal">
		<smart-modal
			ref="smartForm"
			v-if="chForm != null"
			:chForm="chForm"
			@imprimir="fxImprimir"
			@salvar="saveDataForm"
		/>
	</div>
</template>
<script>
	import SmartModal from '../../../models/create-form/components/mdFormLoad.vue';
	import { clone } from 'lodash';
	import WBS from 'js/http';
	import toastr from 'toastr';

	export default {
		name: 'ModalSmartForms',
		components: { SmartModal },
		inject: ['row', 'assets'],
		data() {
			return {
				chForm: null,
				block: false,
				tmp: [],
			};
		},
		computed: {
			template() {
				return this.tmp.find(
					(e) => e.cod == this.chForm.settings.printInfo
				);
			},
		},
		methods: {
			fxImprimir(data) {
				if (this.template != undefined) {
					this.block = true;
					let sData = {
						data: {
							data: this.row,
							form: data,
							tmp: this.template,
						},
						loader: 'ordem_servico',
					};

					// console.log(sData)
					WBS.send(
						'protected-custom-replaceDocument',
						sData,
						(resp) => {
							this.block = false;
							// console.log(resp);
							if (resp.status == 'success') {
								window.open(resp.data);
							} else {
								console.log(resp);
								if (typeof resp == 'string') {
									toastr.error(resp);
								} else {
									if (resp.msgs == undefined) {
										toastr.error('Erro Inesperado');
									} else {
										resp.msgs.forEach((msg) => {
											toastr.error(msg);
										});
									}
								}
							}
						}
					);
				}
			},
			saveDataForm(data) {
				const sData = {
					formData: data,
					savaInfo: this.chForm.settings.saveInfo,
					osId: this.row.cod,
				};
				WBS.send('protected-save-smartFormOS', sData, (resp) => {
					if (resp.status == 'success')
						toastr.success('Dados salvos com sucesso!');
					else {
						toastr.error('Erro ao salvar formulário!');
						console.log(resp);
					}
				});
			},
			open(id) {
				return new Promise((response, reject) => {
					const form = this.assets.sForms.find(
						(item) => item.cod == id
					);
					this.chForm = JSON.parse(JSON.stringify(form));

					const loadData = {
						savaInfo: form.settings.saveInfo,
						formId: form.cod,
						rowId: this.row.cod,
					};

					WBS.send(
						'protected-read-SmartFormReadData',
						loadData,
						(resp) => {
							if (resp.status == 'success') {
								this.$refs.smartForm.load(resp.data);
							}
							$(this.$refs.modal).modal('show');
							response();
						}
					);
				});
			},
		},
		mounted() {
			WBS.send('protected-read-gridTemplates', (resp) => {
				this.tmp = resp.data;
			});
		},
	};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/actions-components/smart-forms.vue